import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Cliquez sur le bouton ci-dessous pour vérifier et confirmer vos informations de paiement.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Nous travaillons avec Stripe pour gérer les paiements. Stripe est la plateforme de paiement la plus sécurisée, utilisée par les plus grandes entreprises mondiales.',
      form: {
        terms_acceptance: {
          label:
            'En continuant, vous acceptez notre <FoodAmigosTerms>Contrat de services</FoodAmigosTerms> et le <StripeTerms>Contrat de compte connecté Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements:
          'Stripe a signalé certaines informations client comme manquantes ou invalides. Veuillez corriger les erreurs suivantes en cliquant sur le bouton « Ouvrir le profil Stripe » :',
        errors: 'Erreurs',
        awaiting_verification: 'Votre compte Stripe est en cours de vérification',
        awaiting_verification_description:
          'Nous attendons que Stripe termine la vérification de votre entreprise. Vous pouvez consulter votre profil en attendant.',
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        "Nous travaillons avec Adyen pour gérer les paiements. Adyen est l'une des plateformes de paiement les plus sécurisées, utilisée par les plus grandes entreprises mondiales.",
    },
  },
  labels: {
    verified: 'Votre compte {{paymentGateway}} est vérifié',
    verified_description:
      'La vérification est terminée pour {{paymentGateway}}. Vous pouvez toujours gérer votre profil si nécessaire.',
  },
  buttons: {
    proceed: 'Confirmer mes infos de paiement',
    copy_link: 'Copier le lien',
  },
  toasts: {
    something_went_wrong: 'Une erreur est survenue, veuillez contacter le support technique',
  },
};
